import { useRef } from 'react'

/**
 * Selects all text in an input when it's focused.
 */
export function useSelectOnFocus(): [
    React.Ref<HTMLInputElement>,
    () => void
] {
    const ref = useRef<HTMLInputElement | null>(null)
    return [ref, () => ref.current?.select()]
}
